module.exports = __webpack_public_path__ + "static/media/sweden.48917e04.jpg";